export default {
    name: "Categories",
    data() {
        return{
            categories: []
        }
    },
    mounted: function() {
        this.sendRequest({
            method: 'GET',
            url:'categories/list'
        }).then(({data})=> {
            this.CATEGORIAS = data;
        });
    }
}